export const translationHashes = {
  "de-DE": "0f9c3790",
  "en-CA": "1e6e0e1b",
  "en-GB": "fd6a8f8a",
  "en-US": "8492bdf8",
  "es-ES": "2de34d07",
  "es-US": "f92b1c2f",
  "formattings": "a7aab157",
  "fr-CA": "63f7a7a2",
  "nl-NL": "89490969",
  "sv-SE": "02e1d536"
} as {[lang: string]: string};